import { FC, useState } from 'react';
import { observer, useStore } from 'base/store';
import { Button } from '@base/lib/Button';
import { flushRewardsRecord } from '@pro/common/EggHunt/service';
import Message from '@base/lib/Message';
import FixedContainer from '@base/lib/FixedContainer';

type IProps = {
    fetchData: () => void;
}

export const FlushRecords: FC<IProps> = observer(({ fetchData }) => {
    const { rootStore, userStore } = useStore();
    const { envName } = rootStore.state;
    const { userId, isLogin } = userStore.state;
    const [loading, setLoading] = useState<boolean>(false);

    const handleClick = async () => {
        setLoading(true);
        try {
            await flushRewardsRecord(userId);
            fetchData();
        } catch (e) {
            Message.error(e.message)
        }
        setLoading(false);
    };

    return !isLogin || envName === 'prod' ? null : (
        <FixedContainer placement={['right', 'bottom']} width={'auto'}>
            <Button
                type={'e'}
                loading={loading}
                onClick={handleClick}
            >
                Flush Eggs Records
            </Button>
        </FixedContainer>
    )
});
